import React, { ReactNode } from 'react'
import { IconX } from './icons/x'

type Props = {
	onRemove: () => unknown
	children: ReactNode
}

export function FilterChip({ onRemove, children }: Props) {
	return (
		<div className="filter-chip">
			{children}
			<button className="close" onClick={onRemove}>
				<IconX />
			</button>
		</div>
	)
}
